/**
 * Created BY HMSPL 
 * Last Modified By Balaji on 13/08/2018
 * Last Modified Description : Added error messages
 */

export const Message = {
    'LOGIN_SUCCESS': 'You have successfully logged In',
    'INVALID_USER': 'Please enter valid user name and password'
};

